import React, { useEffect, useState } from 'react';
import CreatePackagingMaster from './CreatePkgMaster';
import PackagingMasterList from './PkgMasterList';
import { getCartoonList } from '../../../services/carton/carton';
import { saveCarton } from '../../../services/carton/carton';
import { toast } from "../../../components/AppToast";
import { updateCarton } from '../../../services/carton/carton';
const PackagingMasterMgt = () => {
    const [cartons, setCartondata] = useState()
    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null); // view/edit
 const [listVersion, setListVersion] = useState();

    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };


    const submitForm = async (formData, id) => {
        try {
            if (id) {
                
                const updateDate = await updateCarton(formData,id);
                if (updateDate.status) {
                     toast.success("Cartons updated successfully");
                    closeForm();
                   setListVersion(v=>v+1);
                }
                else {
                    toast.error('Cartons updation failed')
                }
            }
            else {

                const getesult =  await saveCarton(formData);
                if (getesult.status === 201 || getesult.statusText === "Created") {
                    toast.success("Carton created successfully");
                    closeForm();
                   setListVersion(v=>v+1);
                }
                else {
                    toast.error('Carton creation failed')
                }
            }

        }
        catch (err) {
            throw err;
        }
    }

    return (


        <div className="card shadow-lg main-card">

            {/* ---------- HEADER ---------- */}
            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {!onlyFormVisible
                        ? "Packaging Master"
                        : isCreating
                            ? "Create Packaging Master"
                            : activeRecord?.mode === "edit"
                                ? "Edit Packaging Master"
                                : "View Packaging Master"}
                </h4>
            </div>


            {/* ---------- BREADCRUMBS ---------- */}
            {onlyFormVisible && (
                <nav
                    aria-label="breadcrumb"
                    className="px-3 py-2 border-bottom bg-light"
                >
                    <ol
                        className="breadcrumb mb-0 align-items-center"
                        style={{ ["--bs-breadcrumb-divider"]: "'/'" }}
                    >
                        <li className="breadcrumb-item">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                Packaging Master
                            </button>
                        </li>

                        <li
                            className="breadcrumb-item active fw-semibold text-primary"
                            aria-current="page"
                        >
                            {isCreating
                                ? "Create Packaging Master"
                                : activeRecord?.mode === "edit"
                                    ? "Edit Packaging Master"
                                    : "View Packaging Master"}
                        </li>
                    </ol>
                </nav>
            )}



            <div className="card-body">
                {!onlyFormVisible ? (
                    <PackagingMasterList
                        refreshKey={listVersion}
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) =>
                            setActiveRecord({ mode: "view", data: row })
                        }
                        onEdit={(row) =>
                            setActiveRecord({ mode: "edit", data: row })
                        }
                    />
                ) : (


                    <CreatePackagingMaster
                        initialValues={activeRecord?.data || {}}
                        onCancel={closeForm}
                        onSubmit={submitForm}
                        viewOnly={activeRecord?.mode === "view"}
                        isEdit={activeRecord?.mode === "edit"}
                    />


                )}
            </div>



        </div>
    );
};

export default PackagingMasterMgt;
